<template>
  <div class="page-view">
    <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.page-view {
  margin: 16px 16px 0 16px;
}
</style>